import { Map } from 'immutable';

export function request(userId, { eventId, marketId, selectionId }) {
    return (dispatch, getState) => {
        const leg = getState().betslip
            .getIn([ 'legs', userId ], Map())
            .find(l => (
                l.get('eventId') === eventId && l.get('marketId') === marketId && l.get('selectionId') === selectionId
            ));
        
        if (leg) {
            dispatch({
                type: 'BETSLIP_REMOVE_LEG',
                userId,
                uid: leg.get('uid')
            });
        }
    };
}
